const trustItems = [
  {
    icon: 'ri-truck-line',
    title: 'Free Shipping Over $49',
    desc: 'Orders ship within 1–2 business days',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Since 1997',
    desc: 'Over 25 years supplying parts nationwide',
  },
  {
    icon: 'ri-database-2-line',
    title: '1,000+ Parts In Stock',
    desc: 'Hard-to-find parts ready to ship today',
  },
  {
    icon: 'ri-gift-2-line',
    title: 'Discounted Combined Shipping',
    desc: 'Save more when ordering multiple parts',
  },
  {
    icon: 'ri-shield-check-line',
    title: '30-Day Easy Returns',
    desc: 'Hassle-free returns on all stocked items',
  },
];

export default function TrustBar() {
  return (
    <section className="bg-stone-800 border-b border-stone-700">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 divide-x divide-stone-700">
          {trustItems.map((item) => (
            <div key={item.title} className="flex items-center gap-3 px-5 py-4">
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-amber-400 text-xl`} />
              </div>
              <div className="min-w-0">
                <div className="text-white font-semibold text-xs leading-tight whitespace-nowrap">
                  {item.title}
                </div>
                <div className="text-stone-400 text-[11px] mt-0.5 leading-snug truncate">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
